<nav class="nav nav-secondary">
  <!--Account-->
  <a
    attr.aria-label="{{ 'rewards.nav.marketplace.screenreader' | translate }}"
    class="nav-item"
    [routerLink]="['/rewards/marketplace']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label> {{ 'rewards.nav.marketplace' | translate }}</label>
  </a>

  <a
    attr.aria-label="{{ 'rewards.nav.events.screenreader' | translate }}"
    class="nav-item"
    [routerLink]="['/rewards/events']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label> {{ 'rewards.nav.events' | translate }}</label>
  </a>

  <ng-container *notInPopulation="[population.Kids]">
    <a
      attr.aria-label="{{ 'rewards.nav.raffles.screenreader' | translate }}"
      class="nav-item"
      [routerLink]="['/rewards/raffles']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'rewards.nav.lottos' | translate }}</label>
    </a>
  </ng-container>
  
  <a
    class="nav-item d-lg-flex d-none"
    [routerLink]="['/rewards/wallet']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'rewards.nav.wallet.screenreader' | translate: { fgbdefault: 'Move to Wallet page' } }}"
  >
    <label>{{ 'rewards.nav.wallet' | translate }}</label>
  </a>
</nav>
